import { USER_LEGEND, USER_MODE, USER_FONTSIZE } from '../actions/UserActions'

function initialState() {
  return {
    fontSize: 'medium',
    info: {},
    legend: {
      allDisabled: false,
      equivalenceBook: true,
      keyCompetences: true,
      levelsDifficulty: true,
      multipleIntelligences: true,
    },
    mode: 'student',
  }
}

export default function user(state = initialState(), action) {
  switch (action.type) {
    case USER_LEGEND:
      return state ? { ...state, legend: action.payload } : { legend: action.payload }
    case USER_MODE:
      return state ? { ...state, mode: action.payload } : { mode: action.payload }
    case USER_FONTSIZE:
      return state ? { ...state, fontSize: action.payload } : { fontSize: action.payload }
    default:
      return state
  }
}

export class UserSelectors {
  static getUser(state) {
    return state.user
  }

  static getInfo(state) {
    const newUser = state.user
    newUser.info = state.userBook && state.userBook.userBook && state.userBook.userBook.user
    return newUser.info
  }

  static getUserMode(state) {
    const newUser = state.user
    return newUser.mode
  }

  static getLegend(state) {
    return UserSelectors.getUser(state).legend
  }
  static getMode(state) {
    return UserSelectors.getUser(state).mode
  }

  static getLegendDisabled(state) {
    const newState = UserSelectors.getLegend(state)
    const info = UserSelectors.getInfo(state)
    if (info) {
      if (info.role === 'STUDENT') {
        newState.allDisabled = newState.equivalenceBook === false
      } else {
        newState.allDisabled = Object.values(newState).find((value) => value === true) === undefined
      }
      return newState
    }
    return false
  }
}
